module.exports = __webpack_public_path__ + "img/4.efcc1199.svg";